import { Params } from "@angular/router";
import * as RouterReducers from "@ngrx/router-store";

import * as CoreReducer from "../core/store/reducers";

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
}

export interface State {
  router: RouterReducers.RouterReducerState<RouterStateUrl>;
  core_feature: CoreReducer.CoreFeatureState;
}

export const reducers: any = {
  router: RouterReducers.routerReducer,
  core_feature: CoreReducer.reducers,
};
